module.exports = __webpack_public_path__ + "static/media/sg15tj823.bb946513.png";